import firebase from 'firebase/app'
import 'firebase/auth'
import env from './../environments/environment'
firebase.initializeApp(env.integrations.firebase.config)
